import React from 'react';

import {yupResolver} from '@hookform/resolvers/yup';
import Grid from '@material-ui/core/Grid';
import {useStore} from 'effector-react';
import i18next from 'i18next';
import {Controller, useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import * as yup from 'yup';

import {Button, ButtonVariant} from 'components/ui-kit/Button';
import {DatePicker} from 'components/ui-kit/DatePicker';
import {commissioningForm$, commissioningFormChanged, stepChanged} from 'models/documents/create';
import {CommissioningFormData} from 'types';

import {FormContainer, FormField, FormWrapper, NavigationButtonsContainer} from '../common/styled';

const schema = yup.object().shape({
    startCirculationDate: yup.date().required(i18next.t('components.form.required')),
});

export const DocumentForm = () => {
    const {t} = useTranslation();
    const commissioningForm = useStore(commissioningForm$);
    const {control, handleSubmit, formState} = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
        resolver: yupResolver(schema),
        defaultValues: {
            ...commissioningForm,
        },
    });
    const onHandleChanged = (data: CommissioningFormData) => {
        stepChanged(1);
        commissioningFormChanged(data);
    };
    return (
        <FormContainer>
            <form onSubmit={handleSubmit(onHandleChanged)}>
                <FormWrapper>
                    <Grid container>
                        <Grid item xs={12} md={4}>
                            <FormField>
                                <Controller
                                    control={control}
                                    name="startCirculationDate"
                                    render={(props) => (
                                        <DatePicker
                                            {...props}
                                            maxDate={new Date()}
                                            selected={props.value}
                                            label={t('pages.documents.form.startCirculationDate')}
                                        />
                                    )}
                                />
                            </FormField>
                        </Grid>
                    </Grid>
                </FormWrapper>
                <NavigationButtonsContainer>
                    <span />
                    <Button
                        style={{width: 'auto'}}
                        variant={ButtonVariant.Normal}
                        type="submit"
                        disabled={formState.isValid === false}
                    >
                        {t('components.form.nextStep')}
                    </Button>
                </NavigationButtonsContainer>
            </form>
        </FormContainer>
    );
};
